// extracted by mini-css-extract-plugin
export var externalLink = "_7e-0";
export var internalLinkLabel = "_7e-1";